export const SentimentTable = ({ }) => {
    return (
        <div>this is the sentiment table</div>
    )
}